interface ScreenReaderTitleProps {
  accessibleTitle: string;
  sanitizedTitle: string;
}
const ScreenReaderTitle = ({ accessibleTitle, sanitizedTitle }: ScreenReaderTitleProps) => {
  //screen readers need a text title in a dialog but visibility hidden doesn't always work for them
  return (
    <span
      id={`${sanitizedTitle}-dialog-title`}
      style={{
        position: 'absolute',
        width: 1,
        height: 1,
        margin: -1,
        padding: 0,
        border: 0,
        clip: 'rect(0 0 0 0)',
        whiteSpace: 'nowrap',
        overflow: 'hidden'
      }}
    >
      {accessibleTitle}
    </span>
  );
};

export default ScreenReaderTitle;
